export default __webpack_public_path__ + "static/media/duopose.1a0220c4.jpg";